"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

define('viewModels/fourFive/fourFiveTestViewModel',["require", "exports", "knockout", "moment"], function (require, exports, ko, moment) {
    "use strict";

    var FourFiveTestViewModel = function () {
        function FourFiveTestViewModel(fourFiveTest) {
            _classCallCheck(this, FourFiveTestViewModel);

            this.id = ko.observable('');
            this.created = ko.observable('');
            this.type = ko.observable('');
            this.status = ko.observable('');
            this.testDate = ko.observable('');
            this.update(fourFiveTest);
        }

        _createClass(FourFiveTestViewModel, [{
            key: "update",
            value: function update(fourFiveTest) {
                this.id(fourFiveTest.id);
                this.created(moment(fourFiveTest.created).format('DD/MM/YYYY HH:mm:ss'));
                this.type(fourFiveTest.type);
                this.status(fourFiveTest.status);
                this.testDate(fourFiveTest.testDate ? moment(fourFiveTest.testDate).format('DD/MM/YYYY HH:mm:ss') : '');
            }
        }, {
            key: "clear",
            value: function clear() {
                this.id('');
                this.created('');
                this.type('');
                this.status('');
                this.testDate('');
            }
        }]);

        return FourFiveTestViewModel;
    }();

    return FourFiveTestViewModel;
});
//# sourceMappingURL=fourFiveTestViewModel.js.map;
